import { initializeApp, getApp } from 'firebase/app';
import { getRemoteConfig } from 'firebase/remote-config';
import { getFirebaseConfig, getOrganizationAppName } from '../utils/firebase';

// Initialize Firebase (avoid re-initialization)
export function getFirebaseApp() {
  const config = getFirebaseConfig();
  const appName = getOrganizationAppName();

  try {
    // Check if app with this name already exists
    return getApp(appName);
  } catch (error) {
    // App doesn't exist, initialize it
    return initializeApp(config, appName);
  }
}

// Initialize Remote Config with defaults
export function initializeRemoteConfig(defaultConfig = {}) {
  const app = getFirebaseApp();
  const remoteConfig = getRemoteConfig(app);

  // Set default values
  remoteConfig.defaultConfig = {
    feature_flag_new_ui: false,
    feature_flag_beta_features: false,
    banner_text: 'Welcome to our app!',
    maintenance_mode: false,
    ...defaultConfig,
  };

  // Settings for development
  if (process.env.NODE_ENV === 'development') {
    remoteConfig.settings.minimumFetchIntervalMillis = 3000; // 3 seconds in dev
  } else {
    remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour in prod
  }

  return remoteConfig;
}
